import React, { useState } from "react";
import { Drawer, Card } from "antd";
import { SimpleButton } from "@terrestris/react-geo";

function About(props) {

  const [visible, setVisible] = useState(false);
  const toggleDrawer = () => {
    setVisible(!visible);
  };
  // console.log(props);
  return (
    <div>
      <SimpleButton
        style={{ position: "fixed", top: "400px", left: "30px" }}
        onClick={toggleDrawer}
        shape="circle"
        iconName="question"
        tooltip="Sobre..."
        tooltipPlacement="right"
        size="medium"
      />
      <Drawer
        title="Planero Digital"
        placement="right"
        onClose={toggleDrawer}
        visible={visible}
        mask={false}
        style={{ position: "absolute" }}
        width="400px">

        <Card size="small" title="Información">
        <p>Se trata de una singular iniciativa municipal, dado que no es nada frecuente que se lleve a cabo a pesar de las grandísimas ventajas que puede suponer en la vida cotidiana del municipio.</p>
        <p>El Plan General de Ordenación Urbana de Ronda (PGOU) data de 1994, y desde entonces se ha visto alterado o desarrollado por numerosas modificaciones de carácter puntual y por diferentes planes y proyectos de todo tipo que se han ido aprobando durante sus 29 años de vigencia. Además, durante este largo periodo también se han dado diferentes cambios legislativos que han ido afectando al urbanismo local, conformando todo ello un coctel muy complejo de interpretar y de aplicar.</p>
        <p>El objeto del Texto Refundido es unificar en un único documento las determinaciones contenidas en:</p>
        <ul>
        <li>el Plan General de Ordenación Urbanística (PGOU) vigente desde 1994;</li>
        <li>la Adaptación Parcial del PGOU a la LOUA de 2010</li>
        <li>18 Modificaciones Puntuales del PGOU</li>
        <li>16 Estudios de Detalle</li>
        <li>7 Planes Parciales de Ordenación en Suelo Urbanizable Programado</li>
        <li>1 Programa de Actuación Urbanística en Suelo Urbanizable No Programado</li>
        </ul>
        <p>Así pues, el nuevo Texto Refundido constituye una <strong>versión completa y actualizada de todo el planeamiento vigente</strong>, y por tanto no modifica ninguna de las determinaciones contempladas en los documentos tomados en cuenta para su realización.</p>

        </Card>
      </Drawer>
    </div>
  );
}

export default About;
